module.exports = __webpack_public_path__ + "static/media/icon-long-arrow-left.8e549043.svg";